import React, { useState, useEffect } from 'react';
import {
  Card,
  CardImg,
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import RFField from '../../components/Form/RFField';
import RFForm from '../../components/Form/RFForm';
// import { DateTimePicker } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import { ProgressButton } from '../../commons/ProgressButton';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import { ImageCard, DropZone } from '../../commons/controls';
import Services from './services';
import EditorBlog from './EditorBlog';
import _ from 'lodash';
import Moment from 'moment';
import 'moment/locale/hu';
import SwichButton from '../../commons/SwitchButton';
import { DatetimePicker } from '../../commons/controls';
import SelectField from '../../components/Form/SelectField';
import TimeFormatter from '../../commons/TimeFormatter';
import { parseEditorImage } from '../../commons/utils';
import Wysiwyg from '../../components/Wysiwyg/Wysiwyg';
import ToolbarBase from '../../components/Wysiwyg/toolbar/ToolbarBase';

// momentLocalizer(Moment);
const ROW_STYLE = {marginBottom: '15px'};
const HEADER_STYLE = {marginBottom: "0.5rem", fontWeight: 500, lineHeight: 1.2, fontSize: "1.25rem"};

const BlogForm  = (props) => {

  let selected = false;

  const {
    id,
    setId,
    modositas,
    showModalForm,
    toggleShowModalForm,
    globals
  } = props;

  const [paramLang, toggleParamLang] = useState(false);
  const [langHun, toggleLangHun] = useState(true);
  const [closeSubmit, toggleCloseSubmit] = useState(false);
  const [submitButtonLoading, toggleSubmitButtonLoading] = useState(false);
  const [showModalTartalom, toggleShowModalTartalom] = useState(false);
  const [showCoverModal, toggleShowCoverModal] = useState(false);
  const [formStatus, setFormStatus] = useState('DATA');
  const [formCim, setFormCim] = useState('');
  const [formCimEng, setFormCimEng] = useState('');
  const [formTartalom, setFormTartalom] = useState('');
  const [formTartalomEng, setFormTartalomEng] = useState('');
  const [formTartalomSum, setFormTartalomSum] = useState('');
  const [formTartalomSumEng, setFormTartalomSumEng] = useState('');
  const [formPublikalas, setFormPublikalas] = useState(new Date());
  const [formKezdete, setFormKezdete] = useState(null);
  const [formVege, setFormVege] = useState(null);
  const [formElerhetosegKezdete, setFormElerhetosegKezdete] = useState(null);
  const [formElerhetosegVege, setFormElerhetosegVege] = useState(null);
  const [formHelyszinek, setFormHelyszinek] = useState([]);
  const [formCover, setFormCover] = useState(null);
  const [funkcioId, setFunkcioId] = useState(null);
  const [deletedImages, setDeletedImages] = useState([]);

  useEffect(() => {
    if(closeSubmit){
      toggleSubmitButtonLoading(true);
    }
  }, [closeSubmit]);

  useEffect(() => {
    if(submitButtonLoading){
      savePost();
    }
  }, [submitButtonLoading]);

  useEffect(() => {
    if(formStatus === 'LOAD'){
      getPost(null, true);
    }
  }, [formStatus]);

  useEffect(() => {
    if(modositas){
      setFormStatus('LOAD');
    }else{
      clearForm();
    }
    initForm();
  }, []);

  const clearForm = () => {
    setFormStatus('DATA');
    setFormCim('');
    setFormCimEng('');
    setFormPublikalas(new Date());
    setFormKezdete(new Date());
    setFormVege(null);
    setFormElerhetosegKezdete(null);
    setFormElerhetosegVege(null);
    setFormCover(null);
    setFormHelyszinek([]);
    setFormTartalom('');
    setFormTartalomEng('');
    setFormTartalomSum('');
    setFormTartalomSumEng('');
    setFunkcioId(null);
  };

  const saveForm = (close) => {
    if (close) {
      toggleCloseSubmit(true);
    } else {
      toggleSubmitButtonLoading(true);
    }
  }

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });

        if (formHelyszinek.length == 0 && !modositas && res[0].length === 1) {
          let h = formHelyszinek ? formHelyszinek : [];
          h.push(res[0][0]);
          setFormHelyszinek(h);
        }
        
        callback(options);
      }
    });
  }

  const initForm = () => {
    Services.initPost((err, res) => {
      if(!err){
        toggleParamLang(res[0].eng);
      }
    });
  }

  const getPost = (currId, firstLoad) => {
    Services.getPost(currId || id, (err, res) => {
      if (!err) {
        setFormStatus('DATA');
        setFormTartalom(res[0].tartalom);
        setFormTartalomEng(res[0].tartalomEng);
        setFormCim(res[0].cim);
        setFormCimEng(res[0].cimEng);
        setFormPublikalas(res[0].publikalas)
        setFormKezdete(res[0].kezdete);
        setFormVege(res[0].vege);
        setFormElerhetosegKezdete(res[0].elerhetosegKezdete);
        setFormElerhetosegVege(res[0].elerhetosegVege);
        setFormCover(res[0].objects[0]);
        setFormHelyszinek(res[0].helyszinek);
        setFormTartalomSum(res[0].tartalomSum);
        setFormTartalomSumEng(res[0].tartalomSumEng);
        setFunkcioId(res[0].funkcioid);
        if(!firstLoad) toggleShowModalTartalom(!showModalTartalom);
      } else {
        setFormStatus('NETW');
      }
    });
  }

  const savePost = () => {
    let submitObj = {};
    let objects = [];
    objects.push(formCover);

    submitObj.id = id; 
    submitObj.cim = emptyOrNull(formCim);
    submitObj.cimEng = emptyOrNull(formCimEng);
    submitObj.publikalas = formPublikalas && TimeFormatter.formatIso(formPublikalas);
    submitObj.kezdete = formKezdete && TimeFormatter.formatIso(formKezdete);
    submitObj.vege = formVege && TimeFormatter.formatIso(formVege);
    submitObj.elerhetosegKezdete = formElerhetosegKezdete && TimeFormatter.formatIso(emptyOrNull(formElerhetosegKezdete));
    submitObj.elerhetosegVege = formElerhetosegVege && TimeFormatter.formatIso(emptyOrNull(formElerhetosegVege));
    submitObj.tartalom =  emptyOrNull(formTartalom);
    submitObj.tartalomEng =  emptyOrNull(formTartalomEng);
    submitObj.tartalomSum = emptyOrNull(formTartalomSum);
    submitObj.tartalomSumEng = emptyOrNull(formTartalomSumEng);
    submitObj.helyszinIds = emptyOrNull(formHelyszinek) && formHelyszinek.map(h => {return h.id });
    submitObj.objects = objects;
    submitObj.funkcioid = funkcioId || undefined;

    if (modositas) {
      Services.editPost(submitObj, (err) => {
        if (!err) {
          globals.addSuccess('Bejegyzés módosítva!');
          if(closeSubmit){
            toggleShowModalForm();
          }else{
            getPost();
          }
        }else{
          toggleCloseSubmit(false);
        }
        toggleSubmitButtonLoading(false);
        setFunkcioId(null);
      });
    } else {
      Services.addPost(submitObj, (err, res) => {
        if (!err) {
          globals.addSuccess('Bejegyzés felvéve!');
          if(closeSubmit){
            toggleShowModalForm();
          }else{
            setId( res[0], () => getPost(res[0]));
          }
        }else{
          toggleCloseSubmit(false);
        }
        toggleSubmitButtonLoading(false);
      });
    }

    if(funkcioId) {
      for(const src of deletedImages) {
        Services.deleteEditorImage(funkcioId, src.split('/').at(-1), () => {});
      }
    }
  }

  const onDropCover = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = formCover || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
        });

        setFormCover(files[0]);
      };
      reader.readAsBinaryString(file);
    });
  }

  const listImages = (callback) => {
    Services.listEditorImages((err,res) => {
      if(!err){
        callback(res[0]);
      }
    });
  }

  const addImage = async (file) => {
    const { url, funkcioid } = await parseEditorImage((cb) => Services.uploadEditorImage(file, funkcioId || id || undefined, cb));
    setDeletedImages(prev => prev.filter(x => x !== url));
    if(!modositas) {
      setFunkcioId(funkcioid);
    }
    return url;
  }

  const handleFormCancelClick = () => {
    if(funkcioId) {
      Services.deleteEditorImages(funkcioId, () => {});
    }
    setFunkcioId(null);
    setDeletedImages([]);
    toggleShowModalForm();
  }

  const removeImage = (node) => {
    const src = node.attrs.src;
    if(src?.startsWith('data:')) return;

    setDeletedImages(prev => [...prev, src]);
  }

  const emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      switch (type) {
        case 'FORMPUBLIKALAS':
          setFormPublikalas(Moment(e).startOf('day'))
          break;
        case 'FORMKEZDETE':
          setFormKezdete(Moment(e).startOf('day'))
          break;
        case 'FORMELERHETOSEGKEZDETE':
          setFormElerhetosegKezdete(Moment(e).startOf('day'))
          break;
        case 'FORMPUBVEGE':
          console.log('ee', e,Moment(e).endOf('day'))
          setFormVege(Moment(e).endOf('day'))
          break;
        case 'FORMELERHETOSEGVEGE':
          setFormElerhetosegVege(Moment(e).endOf('day'))
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMPUBLIKALAS':
          setFormPublikalas(v === '' ? null : e)
          break;
        case 'FORMKEZDETE':
          setFormKezdete(v === '' ? null : e)
          break;
        case 'FORMELERHETOSEGKEZDETE':
          setFormElerhetosegKezdete(v === '' ? null : e)
          break;
        case 'FORMPUBVEGE':
          setFormVege(v === '' ? null : e)
          break;
        case 'FORMELERHETOSEGVEGE':
          setFormElerhetosegVege(v === '' ? null : e)
          break;
        default:
          break;
      }
    }
  }
  
  const renderForm = () => {
    return (
      <React.Fragment>
        <RFForm>
          <div className="row" style={ROW_STYLE}>
            <div className="col-md-8" style={{paddingRight: '2px'}}>
              <RFField
                label={langHun ? "Cím: ": "Cím: (angol)"}
                name={langHun ? "formCim: ": "formCimEng"}
                value={langHun ? formCim : formCimEng }
                onChange={langHun ? (e => setFormCim(e.target.value)) : (e => setFormCimEng(e.target.value))}
                required={langHun}
              />           
            </div>
            <div className="col-md-4">
              <DatetimePicker
                  label={'Bejegyzés időpontja:'}
                  id={"formPublikalas"}
                  name={"formPublikalas"}
                  value={formPublikalas && new Date(formPublikalas)}
                  //onChange={(e,v) => {setFormPublikalas(v === '' ? null : e)}}
                  onChange={(e,v) => {handleDateChange(e,v,'FORMPUBLIKALAS')}}
                  onSelect={(e,v) => { selected = true }}
                  //onSelect={(e,v) => {setFormPublikalas(v === '' ? null : Moment(e).endOf('day').toString())}}
                  containerClassName="organw-date-time"
                  timePrecision="seconds"
                  // format="YYYY-MM-DD HH:mm"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                  required
                />
            </div>
          </div>
          <div className="row" style={ROW_STYLE}>
            <div className="col-md-3">
              <DatetimePicker
                  label={'Publikálás kezdete:'}
                  id={"formKezdete"}
                  name={"formKezdete"}
                  value={formKezdete && new Date(formKezdete)}
                  // onChange={(e,v) => setFormKezdete(v === '' ? null : e)}
                  onChange={(e,v) => {handleDateChange(e,v,'FORMKEZDETE')}}
                  onSelect={(e,v) => { selected = true }}
                  containerClassName="organw-date-time"
                  timePrecision="seconds"
                  // time
                  // format="YYYY-MM-DD HH:mm"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                  required
                />
            </div>
            <div className="col-md-3">
              <DatetimePicker
                  label={'Publikálás vége:'}
                  id={"formVege"}
                  name={"formVege"}
                  value={formVege && new Date(formVege)}
                  // onChange={(e,v) => setFormVege(v === '' ? null : e)}
                  onChange={(e,v) => {handleDateChange(e,v,'FORMPUBVEGE')}}
                  onSelect={(e,v) => { selected = true }}
                  containerClassName="organw-date-time"
                  timePrecision="seconds"
                  // time
                  // format="YYYY-MM-DD HH:mm"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                />
            </div>
            <div className="col-md-3">
              <DatetimePicker
                  label={'Elérhetőség kezdete:'}
                  id={"formElerhetosegKezdete"}
                  name={"formElerhetosegKezdete"}
                  value={formElerhetosegKezdete && new Date(formElerhetosegKezdete)}
                  //onChange={(e,v) => setFormElerhetosegKezdete( v === '' ? null : e)}
                  onChange={(e,v) => {handleDateChange(e,v,'FORMELERHETOSEGKEZDETE')}}
                  onSelect={(e,v) => { selected = true }}
                  containerClassName="organw-date-time"
                  timePrecision="seconds"
                  // time
                  // format="YYYY-MM-DD HH:mm"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                />
            </div>
            <div className="col-md-3">
              <DatetimePicker
                  label={'Elérhetőség vége:'}
                  id={"formElerhetosegVege"}
                  name={"formElerhetosegVege"}
                  value={formElerhetosegVege && new Date(formElerhetosegVege)}
                  onChange={(e,v) => {handleDateChange(e,v,'FORMELERHETOSEGVEGE')}}
                  onSelect={(e,v) => { selected = true }}
                  //onChange={(e,v) => setFormElerhetosegVege( v === '' ? null : e)}
                  containerClassName="organw-date-time"
                  timePrecision="seconds"
                  // time
                  // format="YYYY-MM-DD HH:mm"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                />
            </div>
          </div>
          <div className="row" style={{...ROW_STYLE, ...{zIndex: 3, position: 'relative'}}}>
            <div className="col-md-12" style={{paddingRight: '2px'}}>
              <SelectField
                label='Helyszínek:'
                variant='async'
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0',
                    zIndex: 3
                  }),
                }}
                name="formHelyszinek"
                id="formHelyszinek"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => setFormHelyszinek(v)}
                loadOptions={_.debounce(loadHelyszinOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={formHelyszinek}
                required
                isMulti
                isClearable
                defaultOptions
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6" style={{paddingRight: '2px'}}>
              <RFField
                type="textarea"
                label={langHun ? "Összefoglaló: ": "Összefoglaló: (angol)"}
                name={langHun ? "formTartalomSum: ": "formTartalomSumEng"}
                value={langHun ? formTartalomSum : formTartalomSumEng }
                onChange={langHun ? (e => setFormTartalomSum(e.target.value)) : (e => setFormTartalomSumEng(e.target.value))}
                required={langHun}
              />  
            </div>
            <div className="col-md-6" style={{paddingRight: '2px'}}>
              <Label for="formCover">{'Borító:' + (langHun ? ' *' : '')}</Label>
              {!formCover &&
                <DropZone id="formCover" onDrop={onDropCover} className="custom-dropzone" accept="image/*" style={{height: '200px'}} />
              }
              {formCover &&
                <ImageCard
                  style={{height: '200px'}}
                  mime={formCover.mime}
                  content={formCover.content}
                  src={formCover.src}
                  poster
                  backgroundColor = "#FFF"
                  onViewClick={() => toggleShowCoverModal(true)}
                  onDeleteClick={() => setFormCover(null)}
                />
              }
            </div>
          </div>
        </RFForm>
        <div className="row">
          <div className="col-12">
            <Label>{langHun ? "Tartalom: *": "Tartalom: (angol)"}</Label>
            {langHun && <Wysiwyg value={formTartalom} onChange={setFormTartalom} toolbar={() => <ToolbarBase />} onImageUpload={addImage} onImageRemove={removeImage} />}
            {!langHun && <Wysiwyg value={formTartalomEng} onChange={setFormTartalomEng} toolbar={() => <ToolbarBase />} onImageUpload={addImage} onImageRemove={removeImage} />}
          </div>
        </div>
      </React.Fragment>
    );
  }

  const renderFormTitle = () => {
    if (modositas) {
      return 'Bejegyzés módosítása';
    }else{
      return 'Új bejegyzés létrehozása';
    }
  }

  const FormHeader = (props) => {
    const {
      toggleLangHun,
    } = props;
  
    return ( 
      <React.Fragment>
        <a style={HEADER_STYLE}>
          {renderFormTitle()}
        </a>
        {paramLang && (
        <SwichButton
          active={langHun}
          trueLabel="Magyar"
          trueToggle={() => toggleLangHun(true)}
          trueWidth={100}
          falseToggle={() => toggleLangHun(false)}
          falseLabel="Angol"
          falseWidth={100}
        />
        )}
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <Modal isOpen={showModalForm} toggle={() => toggleShowModalForm()} backdrop="static" size="lg">
          <ModalHeader tag={() => FormHeader({toggleLangHun: toggleLangHun})} >
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => getPost(id)}
                />),
              DATA: renderForm()
            }[formStatus]}
          </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              loading={submitButtonLoading}
              onClick={() => saveForm(true)}
            >
              {'Mentés'}
            </ProgressButton>
            <Button
              type="button"
              color="secondary"
              onClick={handleFormCancelClick}
            >
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
        {/* TODO visszatenni */}
        {/* <Modal isOpen={showCoverModal} toggle={() => toggleShowCoverModal()} backdrop="static">
          <Card style={{marginBottom: "0", border: "none"}}>
            <Form >
              {formCover &&
                <React.Fragment>
                  <CardImg
                    src={ formCover.src ? formCover.src :  "data:image/bmp;base64," + formCover.content} 
                    onClick={() => toggleShowCoverModal()}
                  />
                  <div style={{display: "flex", flexDirection: "row"}}>
                    <RFFForm
                      placeholder="Kép leírás..."
                      type="text"
                      onChange={(e,v) => setFormCover( {...formCover, alt: v})}
                      value={formCover.alt}
                      disabled={formCover.id}
                      name="formCoverAltTag"
                      id="formCoverAltTag"
                    />
                    <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={() => toggleShowCoverModal()}>
                      OK
                    </Button>
                  </div>
                </React.Fragment>
              }
            </Form>
          </Card>
        </Modal> */}
      </div>
    </div>
  );
}

export default BlogForm;
